import { render, staticRenderFns } from "./ContinuousFilingFormDetailsEscalated.vue?vue&type=template&id=a65c47ec&scoped=true&"
import script from "./ContinuousFilingFormDetailsEscalated.vue?vue&type=script&lang=js&"
export * from "./ContinuousFilingFormDetailsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousFilingFormDetailsEscalated.vue?vue&type=style&index=0&id=a65c47ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65c47ec",
  null
  
)

export default component.exports